import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { Redo } from "@material-ui/icons";
import { fields as adminFields } from "../fields";
import { Payload, Record } from "../types";

interface Props {
  onSetMapping: (from: string, to: string) => void;
  state: Payload<Record>;
  highlightUnmatched?: boolean;
}

// remove passthrough key from fields: adminFields
const fields = Object.fromEntries(
  Object.entries(adminFields).filter(([key]) => key !== "passthrough"),
);

const Fields: React.FC<Props> = ({ state, onSetMapping, highlightUnmatched }) => {
  if (!state.file) return null;

  // Use the first candidate row to determine column headers
  const { data: [candidate] } = state;
  if (!candidate) return null;

  const headers = Object.keys(candidate);
  // Only show up to 5 rows of data
  const rows = state.data.slice(0, 5);

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {headers.map(header => {
              const mapping = state.mapping[header];
              const selected = mapping ? mapping.field : "none";
              const options = Object.keys(fields).filter(fieldKey =>
                ["none", "add_notes", selected].includes(fieldKey) ||
                !Object.keys(state.mapping).some(
                  fk => state.mapping[fk].field === fieldKey,
                ));
              return (
                <TableCell key={header}>
                  <Typography variant="body1" noWrap
                    color={highlightUnmatched && (!mapping || mapping.field === "none") ? "error" : "initial"}
                  ><strong>{header}</strong> <Redo fontSize="small" style={{
                      transform: "rotate(45deg)",
                      marginBottom: -5,
                    }}/>
                  </Typography>
                  <Autocomplete
                    options={options}
                    value={selected}
                    getOptionLabel={(option) => fields[option].label}
                    onChange={(_event, value) =>
                      value && onSetMapping(header, value)
                    }
                    disableClearable
                    autoHighlight
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        margin="dense"
                        variant="outlined"
                        label="HC field"
                      />
                    )}
                    style={{
                      minWidth: "11em",
                    }}
                  />
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              {headers.map(header => (
                <TableCell key={`data-${rowIndex}-${header}`}>{row[header]}</TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Fields;
